import React, { useState, useEffect } from 'react';
import { CardContent, Typography, Box, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import img1 from '../../../assets/Landing/ear.jpg';
import img2 from '../../../assets/Landing/con.jpg';
import img3 from '../../../assets/Landing/lap.jpg';

const Slide = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const slides = [
    {
      id: 1,
      title: 'Business Solutions',
      description: 'Drive success with KALEIDO’s tailored business solutions.',
      image: img1,
      buttonText: 'Learn More',
    },
    {
      id: 2,
      title: 'ICT Services',
      description: 'Boost your tech with KALEIDO’s ICT services',
      image: img2,
      buttonText: 'Explore',
    },
    {
      id: 3,
      title: 'Tax & Legal',
      description: 'Expert tax and legal services at KALEIDO.',
      image: img3,
      buttonText: 'Get Help',
    },
  ];

  const theme = useTheme();

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 5000);

    return () => clearInterval(interval);
  }, [activeIndex]);

  const handlePrev = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
  };

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const handleDotClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <Box
      sx={{
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
        height: '550px',
        bgcolor: 'background.paper',
      }}
    >
      {slides.map((slide, index) => (
        <Box
          key={slide.id}
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundImage: `url(${slide.image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            transform: `translateX(${(index - activeIndex) * 100}%)`,
            transition: 'transform 0.8s ease-in-out, opacity 0.8s ease-in-out',
            opacity: activeIndex === index ? 1 : 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            textAlign: 'center',
          }}
        >
          {/* Optional overlay to darken the image for readability */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            }}
          />
          <CardContent
            sx={{
              position: 'relative',
              zIndex: 1,
              maxWidth: '600px',
            }}
          >
            <Typography variant="h3" fontFamily="sans-serif" component="div">
              {slide.title}
            </Typography>
            <Typography variant="h5" fontFamily="sans-serif" sx={{ mt: 1 }}>
              {slide.description}
            </Typography>
            <div
              style={{
                color: '#ffffff',
                borderColor: '#ffffff',
                display: 'inline-block',
                padding: '6px 12px',
                border: '1px solid',
                cursor: 'pointer',
                marginTop: '16px',
                transition: '0.7s',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.color = '#F7F7F7';
                e.currentTarget.style['border-color'] = '#191919';
                e.currentTarget.style['box-shadow'] = '#191919 0 0px 0px 70px inset';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.color = '#ffffff';
                e.currentTarget.style['border-color'] = '#ffffff';
                e.currentTarget.style['box-shadow'] = '#191919 0 0px 0px 0px inset';
              }}
            >
              {slide.buttonText}
            </div>
          </CardContent>
        </Box>
      ))}

      {/* Navigation Arrows */}
      <IconButton
        onClick={handlePrev}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '10px',
          transform: 'translateY(-50%)',
          color: '#fff',
          zIndex: 2,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
          },
        }}
      >
        <ArrowBackIosIcon />
      </IconButton>

      <IconButton
        onClick={handleNext}
        sx={{
          position: 'absolute',
          top: '50%',
          right: '10px',
          transform: 'translateY(-50%)',
          color: '#fff',
          zIndex: 2,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
          },
        }}
      >
        <ArrowForwardIosIcon />
      </IconButton>

      {/* Navigation Dots */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '10px',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '8px',
        }}
      >
        {slides.map((_, index) => (
          <Box
            key={index}
            onClick={() => handleDotClick(index)}
            sx={{
              width: '24px',
              height: '4px',
              bgcolor: activeIndex === index ? '#fff' : 'rgba(255, 255, 255, 0.5)',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Slide;
